import { Link } from '@remix-run/react';
import type { ReactNode } from 'react';
import { useToolTranslation } from '@shared/@services/translation/tool';
import { PROJECT_NAME } from '@controls/utils';

interface Props {
  children?: ReactNode;
}

export default function BaseLayout({ children }: Props) {
  const { t } = useToolTranslation();
  return (
    <>
      <div className='primary-layout lg:mx-14'>
        <main className='flex min-h-screen justify-center'>
          <section className='w-full'>{children && children}</section>
        </main>
        <footer className='flex flex-col items-center justify-between gap-2 px-4 py-6 text-center text-xs font-base text-gray-400 sm:flex-row sm:px-8 sm:text-sm'>
          <p className='text-center sm:text-left'>
            @ 2026 {PROJECT_NAME}. {t('common:copy_right')}
          </p>
          <div className='mt-1 flex items-center sm:mt-0'>
            <Link to='/terms' className='hover:text-white transition-colors'>
              {t('common:terms')}
            </Link>
            <span className='mx-2'>|</span>
            <Link to='/privacy' className='hover:text-white transition-colors'>
              {t('common:privacy')}
            </Link>
          </div>
        </footer>
      </div>
    </>
  );
}
